export default "__VITE_ASSET__DUcqro9c__"